import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-490bcb2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Our Photos", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Some of our favorite photos from over the years", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotoViewer = _resolveComponent("PhotoViewer")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_PhotoViewer, { images: _ctx.ourImages }, null, 8, ["images"])
  ]))
}